// root-store
export const USER_STATE_STORAGE_KEY = "lotterychat-user-state-storage-key-V10"
// auth-store
export const SECURE_STORAGE_KEY_TOKEN = "SECURE_STORAGE_KEY_TOKEN_V1"
// fallback when SecureStore unavailable/unreliable on some Android devices/builds
export const STORAGE_KEY_TOKEN_FALLBACK = "STORAGE_KEY_TOKEN_FALLBACK_V1"
export const SECURE_STORAGE_KEY_DEVICE_ID = "SECURE_STORAGE_KEY_DEVICE_ID"
export const STORAGE_KEY_CLIENT_ID = "STORAGE_KEY_CLIENT_ID"
export const HAVE_BEEN_PASS_INTRO = "HAVE_BEEN_PASS_INTRO"
export const HAVE_BEEN_PASS_PRIVACY = "HAVE_BEEN_PASS_PRIVACY"

// chat-store (device-local soft delete list)
export const DELETED_CHAT_IDS = "DELETED_CHAT_IDS"

// navigation persistence (react-navigation)
export const NAVIGATION_PERSISTENCE_KEY = "NAVIGATION_STATE"
